module.exports = __webpack_public_path__ + "img/pic08@2x.edc4b001.png";